<template>
  <RouterLink :id="id" class="navigation-link" :to="target">{{ text }}</RouterLink>
</template>

<script>
export default {
  name: 'navigation-link',
  props: {
    id: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    target: {
      type: String,
      required: true,
    },
  },
};
</script>
